import React, { useEffect, useState } from "react";
import { CommonService } from "../../services/common/common.service";
import { useTranslation } from "react-i18next";
import { EmployeesProvider } from "../../store";
import HeaderComponent from "../../components/header/header.component";
import { headerWithoutTableHeight } from "src/statics/header";
import EmployeeDetailsContent from "src/components/employee-details-content/employee-details-content.component";
import { EmployeesService } from "src/services/employees/employees.service";

export default function EmployeeDetailsPage(props: any) {
  const commonService = new CommonService();
  const employeesService = new EmployeesService();
  const employeeId = props.match.params.id;
  const empty: any = {
    name: '',
    family_name: '',
    imageURL: '',
    phone_number: ''
  };
  const [employee, setEmployee]: any = useState(empty);

  async function getEmployeeDetails(employeeId: string) {
    const employee = await employeesService.getEmployeeById(employeeId);
    setEmployee(employee);
  }

  const [t] = useTranslation();
  useEffect(() => {
    const title = t("building details");
    commonService.setTitle(title);
    getEmployeeDetails(employeeId);
    // eslint-disable-next-line
  }, []);

  return (
    <div>
      <HeaderComponent
        title={employee.name + ' ' + employee.family_name}
        subtitle={employee.phone_number}
        icon={employee.imageURL ? employee.imageURL : "/no-user.png"}
        layout="half"
        headerHeight={headerWithoutTableHeight}
        displayMenu={true}
      />
      <EmployeesProvider>
        <EmployeeDetailsContent emplyeeId={employeeId} />
      </EmployeesProvider>
    </div>
  );
}
